<template>
  <div>
    <div class="pos-abs-fixed">
      <v-toolbar dense color="grey lighten-2" tabs class="border-bottom">
        <v-toolbar-title>{{ pageTitle }}</v-toolbar-title>

        <v-spacer></v-spacer>

        <v-tooltip bottom>
          <v-btn icon @click="$emit('close')" slot="activator">
            <v-icon dark>close</v-icon>
          </v-btn>
          <span>Cancelar</span>
        </v-tooltip>
        <v-tooltip bottom>
          <v-btn icon class="elevation-5" color="primary" @click="$emit('save')" slot="activator" :loading="loading">
            <v-icon>done</v-icon>
          </v-btn>
          <span>Salvar</span>
        </v-tooltip>

        <template v-slot:extension>
          <v-tabs v-model="tab" color="grey lighten-2">
            <v-tabs-slider color="grey darken-4"></v-tabs-slider>

            <v-tab>Dados</v-tab>
            <v-tab>Informações</v-tab>
            <v-tab>Observações</v-tab>
            <v-tab>Atividades ({{ qtdeAtividades }})</v-tab>
            <v-tab>Projetos ({{ qtdeProjetos }})</v-tab>
          </v-tabs>
          <v-layout class="grid-actions" v-if="tab == 3">
            <v-text-field 
              class="pt-0"
              v-show="showSearch"
              @input="search" 
              @keyup.esc="showSearch = false"
              v-model="searchTerm" 
              prepend-inner-icon="search"
              clearable
              hide-details
              autofocus
            ></v-text-field>

            <v-tooltip bottom>
              <v-btn flat icon small slot="activator" @click="showSearch = !showSearch">
                <v-icon>{{ iconSearch }}</v-icon>
              </v-btn>
              <span>Pesquisar</span>
            </v-tooltip>

            <v-menu bottom left>
              <template v-slot:activator="{ on }">
                <v-tooltip bottom>
                  <v-btn flat icon small slot="activator" v-on="on">
                    <v-icon>filter_list</v-icon>
                  </v-btn>
                  <span>Filtrar</span>
                </v-tooltip>
              </template>

              <v-list dense subheader>
                <v-list-tile @click="$emit('filtraAtividades', 'Todas')">
                  <v-list-tile-title>
                    Todas
                  </v-list-tile-title>
                </v-list-tile>
                <v-list-tile @click="$emit('filtraAtividades', 'Projeto')">
                  <v-list-tile-title>
                    Projeto
                  </v-list-tile-title>
                </v-list-tile>
                <v-list-tile @click="$emit('filtraAtividades', 'Vinculadas')">
                  <v-list-tile-title>
                    Vinculadas
                  </v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>

            <v-tooltip bottom>
              <v-btn flat icon small slot="activator" @click="$emit('refreshAtividadesProjeto')">
                <v-icon>refresh</v-icon>
              </v-btn>
              <span>Atualizar</span>
            </v-tooltip>

            <v-tooltip bottom v-if="permiteAlterar">
              <span>Opções</span>
              <v-menu bottom left slot="activator">
                <v-btn flat icon small slot="activator">
                  <v-icon>more_vert</v-icon>
                </v-btn>
                <v-list class="py-0">
                  <v-list-tile @click='$emit("abreModalListAtividade", null)'>
                    <v-list-tile-title>
                      <v-icon small left>add_circle</v-icon>Vincular Atividades
                    </v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile @click='$emit("removerVinculoAtividade", null)'>
                    <v-list-tile-title>
                      <v-icon small left>remove_circle</v-icon>Remover Vínculo
                    </v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile @click='$emit("editItemSelected")'>
                    <v-list-tile-title>
                      <v-icon small left>edit</v-icon>Alterar
                    </v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile @click='$emit("deleteItemSelected")'>
                    <v-list-tile-title>
                      <v-icon small left>delete</v-icon>Excluir
                    </v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile @click='$emit("finalizaItemSelected")'>
                    <v-list-tile-title>
                      <v-icon small left>check</v-icon>Finalizar
                    </v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile @click='$emit("voltaStatusItemSelected")'>
                    <v-list-tile-title>
                      <v-icon small left>undo</v-icon>Voltar Status
                    </v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile @click='$emit("abreModalEditPrevisao", null)'>
                    <v-list-tile-title>
                      <v-icon small left>event</v-icon>Setar Previsão
                    </v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile @click='$emit("abreModalEditSituacao", null)'>
                    <v-list-tile-title>
                      <v-icon small left>description</v-icon>Setar Situação
                    </v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile @click='$emit("abreModalEditResponsavel", null)'>
                    <v-list-tile-title>
                      <v-icon small left>person</v-icon>Setar Responsável
                    </v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile @click='$emit("abreModalEditTipoAtividade", null)'>
                    <v-list-tile-title>
                      <v-icon small left>label_important</v-icon>Setar Tipo Atividade
                    </v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile @click='$emit("abreModalEditColaborador", null)'>
                    <v-list-tile-title>
                      <v-icon small left>group_add</v-icon>Setar Colaborador
                    </v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile @click='$emit("abreModalEditCliente", null)'>
                    <v-list-tile-title>
                      <v-icon small left>group_add</v-icon>Setar Cliente
                    </v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile @click='$emit("abreModalEditTag", null)'>
                    <v-list-tile-title>
                      <v-icon small left>label</v-icon>Setar Tag
                    </v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile @click='$emit("abreModalSetaOcorrencia", null)'>
                    <v-list-tile-title>
                      <v-icon small left>comment</v-icon>Setar Ocorrência
                    </v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile @click='$emit("abreModalEditWorkflow", null)'>
                    <v-list-tile-title>
                      <v-icon small left>timeline</v-icon>Setar Workflow
                    </v-list-tile-title>
                  </v-list-tile>
                </v-list>
              </v-menu>
            </v-tooltip>
          </v-layout>
          <v-layout class="grid-actions" v-if="tab == 0">
            <v-tooltip bottom>
              <v-btn icon class="mx-0" slot="activator" @click="$emit('showInfoColumn')">
                <v-icon :style="showInfoColumnStyle">keyboard_tab</v-icon>
              </v-btn>
              <span>{{ textColumnExpandRetract }}</span>
            </v-tooltip>
          </v-layout>
        </template>
      </v-toolbar>
    </div>
    <v-tabs-items v-model="tab">
      <v-tab-item>
        <slot name="dados"></slot>
      </v-tab-item>
      <v-tab-item>
        <slot name="informacoes"></slot>
      </v-tab-item>
      <v-tab-item>
        <slot name="observacoes"></slot>
      </v-tab-item>
      <v-tab-item>
        <slot name="atividades"></slot>
      </v-tab-item>
      <v-tab-item>
        <slot name="projetos"></slot>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import { clearTimeout, setTimeout } from 'timers';

export default {
  props: ['idProjeto', 'permiteAlterar', 'loading', 'qtdeAtividades', 'qtdeProjetos', 'showInfoColumn'],
  name: 'TabsProjeto',
  data: () => ({
    pageTitle: 'Projeto',
    tab: null,
    searchTerm: '',
    showSearch: false,
    timeout: null,
  }),
  methods: {
    search() {
      clearTimeout(this.timeout);

      this.timeout = setTimeout(() => {
        this.$emit('searchAtividade', this.searchTerm);
      }, 500);
    },
  },
  computed: {
    showInfoColumnStyle() {
      return this.showInfoColumn ? {} : { transform: 'scaleX(-1)' };
    },
    textColumnExpandRetract() {
      return this.showInfoColumn ? 'Recolher Coluna' : 'Expandir Coluna';
    },
    iconSearch() {
      return this.showSearch ? 'clear' : 'search';
    }
  }
}
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}
.border-bottom > :first-child {
  border-bottom: 2px solid #999;
}
.pos-abs-fixed {
  z-index: 5;
  position: relative;
  padding-bottom: 90px;
}

.pos-abs-fixed > :first-child {
  position: fixed;
}
</style>